var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5V9C16 9.55228 16.4477 10 17 10H21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 23H9C7.89543 23 7 22.1046 7 21V7C7 5.89543 7.89543 5 9 5H16L21 10V21C21 22.1046 20.1046 23 19 23Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15V13ZM11 15C10.4477 15 10 14.5523 10 14C10 13.4477 10.4477 13 11 13V15ZM13 17C13.5523 17 14 17.4477 14 18C14 18.5523 13.5523 19 13 19V17ZM11 19C10.4477 19 10 18.5523 10 18C10 17.4477 10.4477 17 11 17V19ZM17 15H11V13H17V15ZM13 19H11V17H13V19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRounded);
export default __webpack_public_path__ + "static/media/document-rounded.f496957666c410d587fdba7d8848fbe8.svg";
export { ForwardRef as ReactComponent };